import script from "./AuctionItems.vue?vue&type=script&setup=true&lang=js"
export * from "./AuctionItems.vue?vue&type=script&setup=true&lang=js"

import "./AuctionItems.vue?vue&type=style&index=0&id=6ac28d66&scoped=true&lang=css"

import exportComponent from "F:\\kobutsu\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6ac28d66"]])

export default __exports__